import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core'
import { AppSharedPropsStore } from 'src/app'
import { INote, INoteClip } from 'src/call/types'
import { GoogleAuthButton, MicrosoftAuthButton } from 'src/sign_in/ui'

import { CallStore, hasInternalTeamLabelAccess, NotesStore } from '../state'
import { NoteSection } from './ui'

@Component({
  tag: 'page-call-detail-note-annotations-panel',
})
export class AnnotationsPanel {
  @Prop() clips: INoteClip[]
  @Event({ bubbles: false }) delete: EventEmitter<INote>
  @Event({ bubbles: false }) edit: EventEmitter<INote>

  render() {
    return (
      <Host>
        <NoteSection
          label='Annotations'
          color='surface-highest'
          renderHeaderContent={() => {
            if (hasInternalTeamLabelAccess(CallStore.state.access)) {
              return (
                <span class='flex items-center ml-2'>
                  <ui-icon icon='lock' class='p-2px mr-1 text-xs text-surface-base bg-info-warn rounded'></ui-icon>
                  <span class='text-xs font-bold tracking-tighter text-info-warn uppercase'>Internal Team Only</span>
                  {this.clips.length > 0 && (
                    <ui-tooltip>If you share this call only folks from your domain can see this content</ui-tooltip>
                  )}
                </span>
              )
            }
          }}
        >
          {CallStore.state.showSignIn ? (
            <div class='flex flex-col items-center p-4 bg-surface-high rounded-md spacing-y-3'>
              <span class='font-extrabold'>Sign-in to view this content</span>
              <GoogleAuthButton
                class='w-full'
                authUrl={CallStore.state.actions.googleSignInUrl}
                label='Sign in with Google'
              />
              <MicrosoftAuthButton
                class='w-full'
                authUrl={CallStore.state.actions.microsoftSignInUrl}
                label='Sign in with Microsoft'
              />
            </div>
          ) : CallStore.state.annotationsLockedMessage && this.clips.length === 0 ? (
            <div class='flex flex-col justify-center items-center h-40 text-sm bg-surface-high rounded-md spacing-y-2'>
              <span class='m-auto max-w-80% text-center'>
                {CallStore.state.annotationsLockedMessage}{' '}
                <form class='inline' method='post' action={AppSharedPropsStore.state.logoutUrl}>
                  <csrf-token />
                  <input type='hidden' name='_method' value='delete' />
                  <button class='inline underline' type='submit'>
                    Sign Out
                  </button>
                </form>
              </span>
            </div>
          ) : (
            this.clips.map((clip) => (
              <li>
                <call-detail-notes-note-clip
                  key={`call-detail-notes-note-clip-${clip.id}`}
                  clip={clip}
                  showMenu={true}
                  readonly={CallStore.state.readonly}
                  highlit={NotesStore.state.highlightId === clip.note.id}
                  onEdit={({ detail }) => this.edit.emit(detail)}
                  onDelete={({ detail }) => this.delete.emit(detail)}
                />
              </li>
            ))
          )}
        </NoteSection>
      </Host>
    )
  }
}
